export const WALLET_PHRASES = {
    TBC: 3662,
    HOW_DOES_IT_WORK: 805,
    YOUR_AVAILABLE_BALANCE: 16581,
    REQUEST_A_PAYMENT: 3381,
    TRANSACTION_HISTORY: 3498,
    REFERENCE_NUMBER: 3377,
    DATE: 1217,
    TYPE: 3376,
    DESCRIPTION: 1473,
    AMOUNT: 3369,
    UPDATED_AMOUNT: 3679,
    BALANCE: 3378,
    STATUS: 3567,
    ACTION: 796,
    NOTES: 3487,
    NON_TAXABLE: 3379,
    OF_WHICH_IS: 3383,
    EARNINGS_PAID_SEPARATELY: 3380,
    SHOW_ARCHIVED_TRANSACTIONS: 9648,
    CANCEL: 189,
    CLOSE: 3467,
    DISPLAY_CODE: 3651,
    AMAZON_GIFT_CARD: 21660,
    REDEEM_AMAZON_CARD: 21661,
    CARD_RESTRICTIONS: 21664,
    GIFT_CARD_AMOUNT: 16636,
    CLAIM_CODE: 16637,
    REDEEM_NOW: 16638,
    BACK_TO_TRANSACTIONS: 3457,
    BACK_BUTTON: 3477,
    PRE_PAID_CARDS_HELP_MESSAGE: 3829,
    GET_HELP: 3830,
    ONCE_YOU_HAVE_RECEIVED_FIRST_COMPENSATION: 3561,
    NON_MEMBER_SUBTEXT_PAYMENT_STATUS: 16653,
    SUBMIT_BUTTON: 1972,
    STUDY_NUMBER: 967,
    COMPENSATION: 13340,
    PAYMENT_STATUS: 3368,
    CANCEL_TRANSACTION_ARE_YOU_SURE: 16927,
    MINIMUM_AMOUNT: 18871,
    MAXIMUM_AMOUNT: 18870,
    VAT: 19738,
    UPLOAD_MORE_THAN_ALLOWED: 16600,
    UPLOAD_NOT_SUPPORTED: 16601,
    YOU_CAN_UPLOAD_FILES_UP_TO: 19739,
    SUPPORTED_FORMATS: 19740,
    MAXIMUM_SIZE_MB: 19741,
    FILE_CAN_NOT_BE_EMPTY: 19807,
    DRAG_AND_DROP_A_FILE_OR_CHOOSE_TO_UPLOAD: 19742,
    REMOVE_DOCUMENT: 16519,
    MISSING_FIELD_ERROR: 16066,
    DOWNLOAD: 19805,
    VALID_UNTIL: 21882,
    REFERENCE_ID: 21883,
} as const;

export const WALLET_REQUEST_PHRASES = {
    PAYMENT_REQUEST_TITLE: 3582,
    AMOUNT: 3369,
    REPEAT_TITLE: 3458,
    OR_SELECT_TITLE: 3460,
    SELECT_PAYMENT_TITLE: 3459,
    PAYMENT_TYPE_PREPAID_CARD: 3811,
    PAYMENT_TYPE_PREPAID_CARD_DESCRIPTION: 3812,
    PAYMENT_TYPE_AMAZON_GIFT_CARD: 3594,
    PAYMENT_TYPE_AMAZON_GIFT_CARD_DESCRIPTION: 3595,
    PAYMENT_TYPE_CHECK: 1493,
    PAYMENT_TYPE_CHECK_DESCRIPTION: 3451,
    ENTER_AMOUNT_TITLE: 3461,
    REQUEST_SUM_DESCRIPTION: 3462,
    REQUEST_SUM_NON_TAXABLE_DESCRIPTION: 3463,
    NON_TAXABLE_DESCRIPTION: 3380,
    TO_EXISTING_PAYMENT_DESCRIPTION: 3464,
    SEPARATE_PAYMENT_QUESTION: 3465,
    SEPARATE_PAYMENT_POPUP_DESCRIPTION: 3486,
    REQUEST_BUTTON: 16565,
    CONFIRM_BUTTON: 3478,
    CANCEL_BUTTON: 189,
} as const;

export const WALLET_PAYMENT_DETAILS_PHRASES = {
    PAYMENT_DETAILS_TITLE: 3479,
};

export const WALLET_CONFIRMATION_PHRASES = {
    CONFIRMATION_TITLE: 3480,
    PROTECT_DESCRIPTION: 3802,
    PAYMENT_METHOD_LABEL: 1349,
    MOBILE_PHONE_LABEL: 567,
    MOBILE_PHONE_CODE_LABEL: 10656,
    COMPENSATION_AGREEMENT_LABEL: 3563,
    CONFIRM_BUTTON: 3478,
};

export const WALLET_NON_MEMBER_PHRASES = {
    PAYMENT_METHOD_LABEL: 1349,
    OPEN_REGISTRATION_TEXT: 3549,
    SUBMIT_PAYMENT_BUTTON: 11944,
    JOIN_BUTTON: 2735,
};

export const WALLET_REMOVE_DIALOG = {
    CANCEL: 189,
    REMOVE: 1722,
    REMOVE_DIALOG_BODY: 16518,
    REMOVE_DIALOG_TITLE: 16519,
};
